import React, { useState, useEffect, useRef } from "react";
import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";


export const setLoading = (val) => {
    const disp = val ? 'block' : 'none';
    const element = document.querySelector('#loading-animation');
    element.style.display = disp;
}
export const wrapLoading = (func) => {
    document.querySelector('#loading-animation').style.display = 'block';
    // Browsers try to rerender page every 16.6 ms (60 FPS) so we put 20 ms delay to give
    // time for rerender
    setTimeout(() => {
        try {
            func();
        }
        finally {
            document.querySelector('#loading-animation').style.display = 'none';
        }
    }, 20);
}
